'use client'

import {useState} from 'react'
import ProductGridContext, {ProductGridContextProps} from './ProductGridContext'

export default function ({children}) {
	const [retreat, setRetreat] = useState('')
	const [isNotifyPanelOpen, setNotifyPanel] = useState(false)
	const [isFilterPanelOpen, setFilterPanel] = useState(false)

	return (
		<ProductGridContext.Provider value={{
			retreat,
			setRetreat,
			isNotifyPanelOpen,
			setNotifyPanel,
			isFilterPanelOpen,
			setFilterPanel,
		} as ProductGridContextProps}>
			{children}
		</ProductGridContext.Provider>
	)
}
